import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
} from '@mui/material';
import {
  Psychology,
  MenuBook,
  FlightTakeoff,
  Description,
  Groups,
  Support,
  CheckCircle,
} from '@mui/icons-material';

const services = [
  {
    icon: <Psychology sx={{ fontSize: 50 }} />,
    title: 'Career Counselling',
    description: 'Expert guidance on medical career paths, specializations, and future opportunities. Personalized counseling sessions for students and parents.',
    features: ['One-on-one counseling', 'Career assessment tests', 'Parent counseling', 'Specialization guidance'],
  },
  {
    icon: <MenuBook sx={{ fontSize: 50 }} />,
    title: 'Admission Guidance',
    description: 'Complete admission assistance including college selection, application processing, and documentation for MBBS, MD, and MS programs.',
    features: ['College selection', 'Application filling', 'Document verification', 'Admission follow-up'],
  },
  {
    icon: <FlightTakeoff sx={{ fontSize: 50 }} />,
    title: 'Visa & Travel Assistance',
    description: 'End-to-end visa processing, travel arrangements, airport pickup, and initial settling support for abroad studies.',
    features: ['Visa documentation', 'Interview preparation', 'Travel booking', 'Airport pickup'],
  },
  {
    icon: <Description sx={{ fontSize: 50 }} />,
    title: 'Documentation Support',
    description: 'Professional assistance in preparing, verifying, and submitting all required documents for admission and visa processing.',
    features: ['Document checklist', 'Verification support', 'Translation services', 'Notarization help'],
  },
  {
    icon: <Groups sx={{ fontSize: 50 }} />,
    title: 'NEET Counselling',
    description: 'Expert guidance for NEET-UG and NEET-PG counseling process including choice filling, seat allotment, and reporting.',
    features: ['Counseling registration', 'Choice filling', 'Seat allotment help', 'Reporting assistance'],
  },
  {
    icon: <Support sx={{ fontSize: 50 }} />,
    title: 'Post Admission Support',
    description: 'Continued support after admission including hostel arrangements, local guidance, and academic assistance throughout the course.',
    features: ['Hostel arrangement', 'Local guardian support', 'Academic guidance', 'Emergency assistance'],
  },
];

const ServicesList = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'white' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Our{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            Services
          </Box>
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          Comprehensive support at every step of your medical education journey
        </Typography>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateX(10px)',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Box
                        sx={{
                          color: 'primary.main',
                          bgcolor: 'rgba(10, 25, 41, 0.05)',
                          p: 3,
                          borderRadius: 4,
                          textAlign: 'center',
                        }}
                      >
                        {service.icon}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                        {service.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.8 }}>
                        {service.description}
                      </Typography>
                      <List>
                        {service.features.map((feature, idx) => (
                          <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <CheckCircle sx={{ color: 'secondary.main', fontSize: 20 }} />
                            </ListItemIcon>
                            <ListItemText primary={feature} />
                          </ListItem>
                        ))}
                      </List>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServicesList;